module.exports = __webpack_public_path__ + "img/ky.6800896b.svg";